import { DateFilterModel, NumberFilterModel, SetFilterModel, TextFilterModel } from "ag-grid-community";
import { ReactNode } from "react";
import { UseTranslationResponse } from "react-i18next";
import { AgGridSingleFilterModel } from "../types/ag-grid-types";

type TFunction = UseTranslationResponse<"translation">["t"];

const unexpectedFilterTypeTextProvider = (t: TFunction) => t("common:columnFilter.unexpectedFilterType");

export function getFilterModelText(filter: AgGridSingleFilterModel, t: TFunction): ReactNode {
  switch (filter.filterType) {
    case "date":
      return getDateFilterModelText(filter, t);
    case "number":
      return getNumberFilterModelText(filter, t);
    case "set":
      return getSetFilterModelText(filter);
    case "text":
      return getTextFilterModelText(filter);
    default:
      return unexpectedFilterTypeTextProvider(t);
  }
}

function getDateFilterModelText(filter: DateFilterModel, t: TFunction): ReactNode {
// TODO:LOCALIZATION localized date format
  const [dateFrom, dateTo] = [
    filter.dateFrom?.split(" ")[0] ?? "",
    filter.dateTo?.split(" ")[0] ?? "",
  ];

  switch (filter.type) {
    case "lessThan":
      return "< " + dateFrom;
    case "greaterThan":
      return "> " + dateFrom;
    case "inRange":
      return dateFrom + " - " + dateTo;
    case "equals":
      return dateFrom;
    default:
      return unexpectedFilterTypeTextProvider(t);
  }
}

function getNumberFilterModelText(filter: NumberFilterModel, t: TFunction): ReactNode {
  switch (filter.type) {
    case "equals":
      return filter.filter;
    case "greaterThan":
      return "> " + filter.filter;
    case "greaterThanOrEqual":
      return ">= " + filter.filter;
    case "inRange":
      return filter.filter + " - " + filter.filterTo;
    case "lessThan":
      return "< " + filter.filter;
    case "lessThanOrEqual":
      return "<= " + filter.filter;
    default:
      return unexpectedFilterTypeTextProvider(t);
  }
}

function getSetFilterModelText(filter: SetFilterModel): ReactNode {
  return filter.values.join(", ");
}

function getTextFilterModelText(filter: TextFilterModel) {
  return filter.filter;
}
